import { render, staticRenderFns } from "./TabTemplates.vue?vue&type=template&id=f3b2e40c&scoped=true"
import script from "./TabTemplates.vue?vue&type=script&lang=js"
export * from "./TabTemplates.vue?vue&type=script&lang=js"
import style0 from "./TabTemplates.vue?vue&type=style&index=0&id=f3b2e40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b2e40c",
  null
  
)

export default component.exports